export const shadows = {
  light: { none: 'none', sm: 'none', md: 'none', lg: 'none' },
  dark: { none: 'none', sm: 'none', md: 'none', lg: 'none' },
} as const;

export type ShadowToken = keyof typeof shadows.light;
